<div class="shared-public-wrapper reset-password-wrapper">
	<div class="shared-public-card">
		<div class="logo-container">
			<img src="/assets/images/Logo-KeFirma.png" alt="KeFirma Logo" />
		</div>

		<h2>Crea la tua nuova password</h2>
		<p>La tua nuova password deve essere diversa rispetto a quelle utilizzate in precedenza.</p>

		<div class="form-group-shared">
			<label for="pwdNuova">Nuova password</label>
			<div class="input-wrapper-shared">
				<input
					id="pwdNuova"
					[type]="showNew() ? 'text' : 'password'"
					class="form-control-shared"
					[class.is-invalid]="error()"
					placeholder="••••••••"
					[ngModel]="nuovaPassword()"
					(ngModelChange)="nuovaPassword.set($event); checkPassword($event)" />
				<i class="toggle-password-shared bi" [class.bi-eye]="!showNew()" [class.bi-eye-slash]="showNew()" (click)="showNew.set(!showNew())"></i>
			</div>
			<div class="nota-shared">minimo 8 caratteri e almeno 3 delle seguenti regole: 1 maiuscola, 1 minuscola, 1 numero, 1 carattere speciale.</div>
		</div>

		<div class="form-group-shared">
			<label for="pwdConferma">Conferma nuova password</label>
			<div class="input-wrapper-shared">
				<input
					id="pwdConferma"
					[type]="showConfirm() ? 'text' : 'password'"
					class="form-control-shared"
					[class.is-invalid]="error()"
					placeholder="••••••••"
					[ngModel]="confermaNuovaPassword()"
					(ngModelChange)="confermaNuovaPassword.set($event)" />
				<i class="toggle-password-shared bi" [class.bi-eye]="!showConfirm()" [class.bi-eye-slash]="showConfirm()" (click)="showConfirm.set(!showConfirm())"></i>
			</div>
			@if (error()) {
				<div class="error-message-shared">
					<i class="bi bi-exclamation-circle-fill"></i>
					{{ errorMsg() }}
				</div>
			}
		</div>

		<button class="btn-shared-primary" (click)="cambia()" [disabled]="loading()">
			@if (loading()) {
				<span class="spinner-border spinner-border-sm me-2"></span>
			}
			CAMBIA PASSWORD
		</button>

		<div class="link-back-shared link-cancel" (click)="goBack()">Torna indietro</div>
	</div>
</div>
